import { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { ISocialTypes } from 'shared/models/User'

import { selectAgentLinks } from 'features/auth/selectors'

export function useGetAgentLinks() {
  const agentsLinks = useSelector(selectAgentLinks, shallowEqual)

  const socialLinks = useMemo(() => {
    const whatsapp = agentsLinks?.find(social => social.socialType === ISocialTypes.Whatsapp)
    const telegram = agentsLinks?.find(social => social.socialType === ISocialTypes.Telegram)
    const liveChat = agentsLinks?.find(social => social.socialType === ISocialTypes.ActivosBlack)

    return {
      whatsapp,
      telegram,
      liveChat,
    }
  }, [agentsLinks])

  return socialLinks
}
